import { Injectable, EventEmitter } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { ActivatedRoute } from '@angular/router';
import { PlatformCommand, ContentScope } from '@shared/commands/command-base';
import { DialogModel } from '@shared/models/dialog.model';
import { CreateChatConversationCommand } from '@features/task-manager/collaboration/store/collaboration.command';
import { CreateChatConversationAction } from '@features/task-manager/collaboration/store/collaboration.action';
import { ConversationComponentName } from '@features/task-manager/collaboration/store/collaboration.constants';
import { DialogService } from '@shared/services/dialog-service';
import {select, Store} from '@ngrx/store';
import { CollaborationState } from '@features/task-manager/collaboration/store/collaboration.reducer';
import { FileStoreCommonService } from '@features/file-manager/services/file-store-common.service';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {skip, takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {QueryProvider} from '@shared/queries/query-provider';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {SetActivityFeedAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {DynamicFieldItem} from '@shared/components/dynamic-form/dynamic-form-item';
import {DynamicFormService} from '@shared/services/dynamic-form.service';
import {BasketId, Dac6FieldConfigKeys, SourceTypes} from '@features/dac6-reporter/Fields';
import {BasketProvider} from '@shared/models/basket-provider';
import {UpdatePreArrangementCommand, UpdateArrangementCommand} from '@features/dac6-reporter/commands/dac6-reporter.command';
import {Guid} from 'guid-typescript';
import {CommandService} from '@core/services/command.service';
import {Configuration} from '@shared/models/configuration';
import { DetailsInstructionService } from '@shared/services/details-instruction-service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {Dynamic_Grid_Data_Request_Parameters} from '@shared/store/actions/virtual-grid.actions';

@Injectable({
  providedIn: 'root',
})

export class PlatformToolDac6CaseDetailHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  item: any;
  id: string;
  ngUnsubscribe$ = new Subject<void>();
  isAutoTagRefresh: boolean;
  formField: DynamicFieldItem;
  fieldConfig: any;
  editedFields: string[] = [];
  endpointName: string;
  selectedSectionHearderKey: string;
  constructor(
    private dynamicFormService: DynamicFormService,
    private commandService: CommandService,
    private dialogService: DialogService,
    private particleCacheService: ParticleCacheService,
    private collaborationStore: Store<CollaborationState>,
    private queryState: Store<IQueryState>,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private detailsInstructionService: DetailsInstructionService,
    private fileStoreCommonService: FileStoreCommonService) {
      this.invalidateSubject = new InvalidateSubject();
      this.endpointName = 'Dac6Api';
      this.selectedSectionHearderKey = '';
    }

  executeCommand(command: PlatformCommand) {
    this.item = this.magicLinkModel.fieldValues['item'];
    this.id = this.item.id;
    console.log(command);
    switch (command.name) {
      case 'SaveChanges':
        this.save(command);
        break;
      case 'CaseDetailOpenConversationCommand':
        this.openConversation();
        break;
      case 'CaseDetailViewDocumentsCommand':
        this.navigateToCaseFolder();
        break;
      case 'CaseDetailHallmarkTaggingCommand':
        this.openHallmarkTagging();
        break;
    }
  }

  valueChanged($event: any) {
    if ($event && $event.action === 'ApplyTagsSuccess') {
      this.isAutoTagRefresh = true;
      QueryProvider.invokeQuery(this.queryState, `${this.magicLinkModel.fieldValues['SourceType']}RowById`, {'[ID]': this.id});
      this.invalidateSubject.invalidate('ApplyTagsSuccess|' + Guid.create().toString());
      return;
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
    console.log(this.magicLinkModel);
    this.ngUnsubscribe$ = new Subject<void>();
    this.dynamicFormService.initialize();
    this.id = this.magicLinkModel.fieldValues['Id']; // will be gotten from magic link
    this.endpointName = this.magicLinkModel.fieldValues['Api'];
    if (this.magicLinkModel.fieldValues['SourceType'].toString().startsWith(SourceTypes.Arrangement)) {
      this.setAeFieldGridConfig();
    }
    this.trackCaseViewActivity(this.id);
    this.queryState.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse,
      `${this.magicLinkModel.fieldValues['SourceType']}RowById`))
      .pipe(skip(1), takeUntil(this.ngUnsubscribe$)).subscribe(state => {
      if (this.isAutoTagRefresh) {
        this.isAutoTagRefresh = false;
        this.autoTagRefresh(state);
        return;
      }
      const item = state.item;
      if (item && item.cells) {
        this.item = item;
        this.magicLinkModel.fieldValues['item'] = this.item;
        // this.platformSidebarStore.dispatch(new SetActivityFeedAction({type: 'ReferenceCode',
        //   id: this.item.cells['ReferenceCode'].value, title: this.item.cells['CaseId'].value, isDefault: false, isUserAction: false}));
        this.formField = state.formField;
        this.dynamicFormService.emitFormField(this.formField);
        this.dynamicFormService.emitSourceType(this.magicLinkModel.fieldValues['SourceType']);
        this.fieldConfig = state.fieldConfig;
        this.dynamicFormService.emitFieldConfig(this.fieldConfig);
        Object.keys(item.cells).forEach(key => {
          if (!this.item.cells[key]) {
            this.item.cells[key] = {};
          }

          this.item.cells[key].isDirty = false;
          this.item.cells[key].actualValue = item.cells[key].value;
          this.item.cells[key].value = item.cells[key].value;
          this.item.cells[key].displayText = item.cells[key].displayText;
        });
        this.dynamicFormService.emitItems(this.item);
        this.isReadyToLoadContainer();
      }
      this.editedFields.splice(0, this.editedFields.length);
      this.dynamicFormService.emitEditedFields(this.editedFields);
      this.dynamicFormService.emitContainerClass('content  pos-relative');
    });
    QueryProvider.invokeQuery(this.queryState, `${this.magicLinkModel.fieldValues['SourceType']}RowById`, {'[ID]': this.id});
  }

  selectionChanged?($event: any): void {

  }
  onFieldSectionChanged?($event: any): void {
    if($event.metaData && $event.metaData['DirectoryPath']){
      const caseId = this.item.cells['CaseId'].value;
      $event.metaData['DirectoryPath'] = $event.metaData['DirectoryPath'].replace('[CASE_ID]' ,caseId );
    }
    const currentSourceType = BasketProvider.getBasketMappedSourceType(this.magicLinkModel.fieldValues['SourceType']);
    this.detailsInstructionService.openFieldDefinitionFieldDetial($event, currentSourceType);
  }
  onFieldSectionIndexChanged?($event: any): void {
    this.selectedSectionHearderKey = $event;
    if(this.hasHallmarkTagging()){
      this.disableHallmarkTagging(false);
    } else {
      this.disableHallmarkTagging(true);
    }
  }

  disableHallmarkTagging(property){
    if(this.magicLinkModel.breadcrumbBar.items.length > 0){
      let items = this.magicLinkModel.breadcrumbBar.items;
      items.forEach(o=> {
        if(o['id'] === 'Default') {
          o.commands.forEach(command => {
            if(command.name === 'CaseDetailHallmarkTaggingCommand'){
              command.isDisabled = property;
            }
          });
        }
      });
    }
  }

  hasHallmarkTagging() {
    const currentBasket = Configuration.getCurrentBasket();
    if (currentBasket) {
      return currentBasket.basketKey === '' && this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
    }
    return this.selectedSectionHearderKey.toLowerCase().includes('_hallmarktagging');
  }


  private isReadyToLoadContainer(){
    if(this.formField && this.item){
      this.dynamicFormService.emitIsReadyToLoadContainer(true);
    }
    else{
      this.dynamicFormService.emitIsReadyToLoadContainer(false);
    }
  }
  trackCaseViewActivity(id: string){
    const command = new PlatformCommand(`Track${this.magicLinkModel.fieldValues['SourceType']}ViewCommand`,'DAC6Api');
    command.fieldValues['Id'] = id;
    command.fieldValues['SourceType'] = this.magicLinkModel.fieldValues['SourceType'];
    this.commandService.executePlatformCommand(command).subscribe((response: any)=>{
      console.log(response);
    })
  }
  openConversation() {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: this.item.cells['CaseGUID'].value,
        caseId: this.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${this.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      this.item.cells['CaseGUID'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  navigateToCaseFolder() {
    let relativePath = `DAC6 Reporter/[CASE_ID]/${this.magicLinkModel.fieldValues['ToolName']}`;
    const caseId = this.item.cells['CaseId'].value;
    relativePath = relativePath.replace('[CASE_ID]', caseId);
    this.fileStoreCommonService.navigateToClientFolderUsingRelativepath(relativePath);
  }
  openHallmarkTagging() {
    const dialogueModel = DialogModel.create('Hallmark Tagging', 'HallmarkTagSuggestionDialogComponent', {});
    dialogueModel.maxWidth = '600px';
    dialogueModel.minWidth = '600px';
    this.dialogService.showOkCancelDialog(dialogueModel).subscribe(res => {
      if (res.action === 'OK') {
      }
    });
  }

  private autoTagRefresh(state: any) {
    if (!this.item.cells['Suggested_Hallmarks']) {
      this.item.cells['Suggested_Hallmarks'] = {};
    }
    if (!this.item.cells['ApplyTags']) {
      this.item.cells['ApplyTags'] = {};
    }

    if (state.item.cells['Suggested_Hallmarks'] && state.item.cells['Suggested_Hallmarks'].value) {
      this.item.cells['Suggested_Hallmarks'].isDirty = false;
      this.item.cells['Suggested_Hallmarks'].actualValue = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].value = state.item.cells['Suggested_Hallmarks'].value;
      this.item.cells['Suggested_Hallmarks'].displayText = state.item.cells['Suggested_Hallmarks'].displayText;
    }

    if (state.item.cells['ApplyTags'] && state.item.cells['ApplyTags'].value) {
      this.item.cells['ApplyTags'].isDirty = false;
      this.item.cells['ApplyTags'].actualValue = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].value = state.item.cells['ApplyTags'].value;
      this.item.cells['ApplyTags'].displayText = state.item.cells['ApplyTags'].displayText;
    }
  }

  save(command: PlatformCommand){
    this.editedFields = command.fieldValues['editedFields'];
    console.log('Edited Fields In Case Detail Handler ',this.editedFields);
    const item = command.fieldValues['item'];
    console.log('Item in Case Detail Handler ',item);
    if (this.editedFields.length) {
      const command = this.getUpdateCommand(item);
      const currentBasket = BasketProvider.getCurrentBasket();
      switch (currentBasket.id){
        case BasketId.Mexico:
          command.IsHallmarkAutomatedCopy = true;
          break;
        default:
      }
      console.log('getUpdateCommand in Case Detail Handler ',command);
      this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(commandState => {
        // this.snackBarService.showInformation('Pre Arrangement Data Saved');
        QueryProvider.invokeQuery(this.queryState, `${this.magicLinkModel.fieldValues['SourceType']}RowById`, {'[ID]': this.id});
        this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
      });
    } else {
      this.invalidateSubject.invalidate('SaveChanges|' + Guid.create().toString());
    }
  }
  getUpdateCommand(item){
    if(this.magicLinkModel.fieldValues['SourceType'] === 'PreArrangement'){
      return new UpdatePreArrangementCommand(item);
    }
    return new UpdateArrangementCommand(item);
  }

  destroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.dynamicFormService.destroy();
  }

  private setAeFieldGridConfig() {
    const config = Configuration.getSmartGridConfig(Dac6FieldConfigKeys.ArrangmentAEFieldConfigKey);
    config.Parameters['ID'] = this.magicLinkModel.fieldValues['Id'];
    this.particleCacheService.saveUserPreferenceGridSetting(Dynamic_Grid_Data_Request_Parameters,
      Dac6FieldConfigKeys.ArrangmentAEFieldConfigKey,  config.Parameters);
  }
}
